module.exports = __webpack_public_path__ + "static/media/Rec-1.c360e77c.jpg";